/** 排程刊登時間工具（UI 以 Asia/Taipei 顯示，DB 存 UTC 毫秒）。 */

const MINUTE = 60_000;

/** 把時間戳的秒與毫秒歸零（排程只到分鐘）。 */
export function normalizeScheduleTime(ms: number): number {
  return Math.floor(ms / MINUTE) * MINUTE;
}

/** 驗證排程時間：未選或不晚於現在 → 回傳錯誤訊息；合法回傳 null。 */
export function validateScheduleTime(ms: number | null | undefined, now = Date.now()): string | null {
  if (ms == null) return '請先選擇排程刊登時間';
  if (normalizeScheduleTime(ms) <= now) return '排程時間必須晚於現在';
  return null;
}

const taipeiFmt = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Taipei',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

/** 以台北時間格式化為 YYYY-MM-DD HH:mm。 */
export function formatTaipeiMinute(ms: number): string {
  const p = Object.fromEntries(taipeiFmt.formatToParts(new Date(ms)).map((x) => [x.type, x.value]));
  return `${p.year}-${p.month}-${p.day} ${p.hour}:${p.minute}`;
}

/** 台北固定 UTC+8（無日光節約）。 */
const TAIPEI_OFFSET = 8 * 60 * MINUTE;

/** 台北「牆上時間」各欄位（月份 0 起算，同 Date）。 */
export interface WallTime {
  year: number;
  month: number;
  day: number;
  hour: number;
  minute: number;
}

/** 時間戳 → 台北牆上時間（不受瀏覽器時區影響）。 */
export function toTaipeiWall(ms: number): WallTime {
  const d = new Date(ms + TAIPEI_OFFSET);
  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth(),
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
  };
}

/** 台北牆上時間 → 時間戳（秒數歸零）。 */
export function fromTaipeiWall(w: WallTime): number {
  return Date.UTC(w.year, w.month, w.day, w.hour, w.minute) - TAIPEI_OFFSET;
}
